import { Link } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { SheetMenu } from './layout/sheet-menu';

function BreadcrumbComponent({
  title,
  titleLink = null,
  subtitle,
  subtitleLink = null,
  subtitle2,
}) {
  return (
    <div className="flex items-center gap-2">
      <SheetMenu />
      <Breadcrumb className="overflow-x-auto whitespace-nowrap w-full">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink href="/">Asosiy</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink
              asChild
              className={
                subtitle
                  ? 'cursor-pointer'
                  : 'cursor-text text-black dark:text-white'
              }
            >
              <Link to={subtitle ? titleLink : '#'}>{title}</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          {subtitle && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink
                  asChild
                  className={
                    subtitle && !subtitle2
                      ? 'cursor-text text-black dark:text-white'
                      : 'cursor-pointer'
                  }
                >
                  <Link to={subtitle2 ? subtitleLink : '#'}>{subtitle}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
          {subtitle2 && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="text-black dark:text-white">
                  {subtitle2}
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}

export default BreadcrumbComponent;
